import type { NotificationItem } from './types'

export function formatNotificationMessage(
  item: NotificationItem,
  template: string,
  locale: string,
) {
  const parameters: Record<string, string> = item.translationKey === 'notifications.aplAnnouncement'
    ? { message: item.parameters[locale] ?? item.parameters['es-ES'] ?? Object.values(item.parameters)[0] ?? '' }
    : { ...item.parameters }

  // Compatibility for notifications created by older deployments.
  if (parameters.count == null && parameters.issues != null) parameters.count = parameters.issues

  const formatted = Object.entries(parameters).reduce(
    (text, [key, value]) => text.replaceAll(`{${key}}`, String(value)),
    template,
  )
  return formatted.replaceAll(/\{[A-Za-z0-9_.-]+\}/g, '—')
}
